export function userMarketCanMint(nftType: string) {
  let canMint = [
    '111,3',
    '105',
    '101',
    '4',
    '8',
    '5'
  ].includes(nftType)
  return canMint
}
